import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getOpenAIAdsRuntime } from '../lib/openaiAdsTracking.js';
import { getSeoRoute } from '../seo/siteRoutes.js';

export default function OpenAIAdsTracker() {
  const location = useLocation();
  useEffect(() => getOpenAIAdsRuntime()?.observeConsent(), []);
  useEffect(() => {
    const runtime = getOpenAIAdsRuntime();
    runtime?.getContext();
    const route = getSeoRoute(location.pathname);
    if (!route) return;
    runtime?.measure('page_viewed', {
      type: 'contents', contents: [{ id: route.id, content_type: 'page' }],
    }, { key: `${location.key}:${route.path}` });
  }, [location.key, location.pathname, location.search]);
  return null;
}
